import { formSubmitClear, formComplete } from 'actions/forms'
import { notify } from '../utils/notification'
import { getPartnerPlan, getPartnerPlanDocuments } from 'actions/partnerPlan'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PARTNERPLAN_SAVE_REQUEST = 'PARTNERPLAN_SAVE_REQUEST'
export const PARTNERPLAN_SAVE_ERROR = 'PARTNERPLAN_SAVE_ERROR'
export const PARTNERPLAN_SAVE_COMPLETE = 'PARTNERPLAN_SAVE_COMPLETE'

const savePartnerPlan = () => ({
  type: PARTNERPLAN_SAVE_REQUEST,
})

const savePartnerPlanComplete = result => ({
  result,
  type: PARTNERPLAN_SAVE_COMPLETE,
})

export const editPartnerPlan = (payload, formId, role = constants.PARTNERPLAN.ROLE.MYPLANS, redirect = true) => (dispatch) => {
  dispatch(savePartnerPlan())
  agent.PartnerPlans.update(payload).then((response) => {
    dispatch(savePartnerPlanComplete(response))
    dispatch(notify('Partner plan saved'))
    if (redirect) {
      dispatch(getPartnerPlan(payload.loggedin_employee_id, payload.employee_id, payload.year))
      dispatch(getPartnerPlanDocuments(payload.employee_id, payload.year, payload.planstatus, role))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner plan, please try again later', 'warning'))
      // console.warn('Err <editPartnerPlan>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}

export const editPartnerPlanComments = (payload, formId, role = constants.PARTNERPLAN.ROLE.MYPLANS, redirect = true) => (dispatch) => {
  dispatch(savePartnerPlan())
  agent.PartnerPlans.updatecomments(payload).then((response) => {
    dispatch(savePartnerPlanComplete(response))
    dispatch(notify('Partner plan saved'))
    if (redirect) {
      dispatch(getPartnerPlan(payload.loggedin_employee_id, payload.employee_id, payload.year))
      dispatch(getPartnerPlanDocuments(payload.employee_id, payload.year, payload.planstatus, role))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner plan, please try again later', 'warning'))
      // console.warn('Err <editPartnerPlan>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}




// WEBPACK FOOTER //
// ./src/actions/partnerPlanForm.js